import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import apiClient from "common/src/api/ApiClient";

const accessLogAPI = createSlice({
    name: 'accessLog',
    initialState: {
        list: []
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAccessLogPage.fulfilled, (state, action) => {
            state.list = action.payload;
        })
    }
});

export const fetchAccessLogPage = createAsyncThunk(
    'accessLog/fetch/page',
    async ({page, filter, sort}) => {
        const response = await apiClient.get(`/api/v1/audit`, null, page, filter, sort);
        return response.data.payload
    }
);

export default accessLogAPI.reducer;